import { merge } from "lodash-es";
import { useMemo } from "react";

import { ScheduleHelper } from "@/common/helpers/schedule";
import { ScheduleEntryDto } from "@/core/api/generated/v1";

import { BaseEntityLinkInheritableProps } from "../Entity/components/EntityLink/BaseEntityLink";
import EntityLink from "../Entity/components/EntityLink/EntityLink";

interface Props {
  entry: ScheduleEntryDto;
  linkProps?: Partial<BaseEntityLinkInheritableProps>;
}

export function ScheduleEntrySourceEntityLink({ entry, linkProps }: Props) {
  const linkPropsComputed = useMemo(
    () =>
      merge(
        {},
        {
          inlineProps: {
            withIcon: true,
            withTooltip: true,
            tooltipProps: { enterDelay: 300, enterNextDelay: 300 },
            displayProps: {
              // hide extra info in title
              vehicle: false,
              contract: false,
              customer: false,
            },
          },
        } satisfies BaseEntityLinkInheritableProps,
        linkProps,
      ),
    [linkProps],
  );

  const sourceEntityDto = useMemo(
    () => ScheduleHelper.getFullSourceEntityFromEntry(entry),
    [entry],
  );
  if (!sourceEntityDto) {
    return null;
  }

  return (
    <EntityLink
      entityType={entry.sourceEntity?.entity?.entityType}
      entityId={sourceEntityDto.id}
      entity={sourceEntityDto}
      linkProps={linkPropsComputed}
    />
  );
}
